<template>
  <section class="works-section">
    <div class="container">
      <h1 class="section-title">НАШИ <span class="highlight">РАБОТЫ</span></h1>
    </div>
    <div ref="scrollContainer" class="works-scroll" @scroll="onScroll">
      <div class="works-container">
        <template v-for="repeat in 3" :key="repeat">
          <div
            v-for="(work, index) in works"
            :key="`${repeat}-${index}`"
            class="work-card"
            :ref="el => setCardRef(el, repeat * works.length + index)"
          >
            <div
              v-if="!loadedItems.has(repeat * works.length + index)"
              class="work-placeholder"
            >
              <div class="loading-spinner"></div>
            </div>

            <img
              v-if="
                work.image && loadedItems.has(repeat * works.length + index)
              "
              :src="work.image"
              :alt="`work image ${index}`"
              class="work-image"
              @load="onImageLoad"
              @error="onImageError"
            />

            <!-- Video content -->
            <video
              v-if="
                work.video && loadedItems.has(repeat * works.length + index)
              "
              :src="work.video"
              controls
              muted
              loop
              class="work-video"
              width="400"
              preload="metadata"
            />
          </div>
        </template>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, onUnmounted } from 'vue'

import img1 from '@/assets/mt-clickbait-works/1.png'
import img3 from '@/assets/mt-clickbait-works/2.png'
import img4 from '@/assets/mt-clickbait-works/3.png'
import img6 from '@/assets/mt-clickbait-works/4.png'
import img7 from '@/assets/mt-clickbait-works/5.png'
import img8 from '@/assets/mt-clickbait-works/6.png'
import img9 from '@/assets/mt-clickbait-works/7.png'
import img10 from '@/assets/mt-clickbait-works/8.png'
import img11 from '@/assets/mt-clickbait-works/9.png'
import img12 from '@/assets/mt-clickbait-works/10.png'
import img13 from '@/assets/mt-clickbait-works/11.png'
import img14 from '@/assets/mt-clickbait-works/12.png'
import img15 from '@/assets/mt-clickbait-works/13.png'
import img16 from '@/assets/mt-clickbait-works/14.png'

const works = ref([
  { image: img1 },
  { image: img3 },
  { image: img4 },
  { image: img6 },
  { image: img7 },
  { image: img8 },
  { image: img9 },
  { image: img10 },
  { image: img11 },
  { image: img12 },
  { image: img13 },
  { image: img14 },
  { image: img15 },
  { image: img16 },
])

const loadedItems = ref(new Set())
const cardRefs = ref(new Map())
const observers = ref(new Map())
const scrollContainer = ref(null)

const setCardRef = (el, index) => {
  if (el) {
    cardRefs.value.set(index, el)
    observeCard(el, index)
  }
}

const observeCard = (element, index) => {
  if (!element || observers.value.has(index)) return

  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        // Add to loaded items
        loadedItems.value.add(index)

        observer.unobserve(entry.target)
        observers.value.delete(index)
      }
    },
    {
      root: scrollContainer.value,
      rootMargin: '200px',
      threshold: 0.1,
    },
  )

  observer.observe(element)
  observers.value.set(index, observer)
}

const onImageError = event => {
  console.error('Failed to load image:', event.target.src)
}

onUnmounted(() => {
  observers.value.forEach(observer => {
    observer.disconnect()
  })
  observers.value.clear()
})
</script>

<style lang="scss" scoped>
.works-section {
  position: relative;
  background-image: url('../../assets/mt_clickbait_services.png');
  background-size: cover;
  background-position: center;
  overflow: hidden;
}

.works-section::after {
  content: '';
  position: absolute;
  inset: 0;
  transform: rotate(180deg);
  transform: scaleX(-1);
  background-color: rgba(0, 0, 0, 0.85);
  pointer-events: none;
  z-index: 0;
}
.works-section > * {
  position: relative;
  z-index: 1;
}

.works-scroll {
  overflow-x: auto;
  width: 100%;
  white-space: nowrap; // чтобы не было переносов

  &::-webkit-scrollbar {
    display: none;
  }

  scrollbar-width: none;
  -ms-overflow-style: none;
}

.section-title {
  margin: 0 !important;
  padding: 60px 0;
  font-size: 96px;
  font-weight: 700;
  font-family: 'Geologica';
  span {
    color: #ffff44;
  }
  @media screen and (max-width: 500px) {
    margin: 0 !important;
    padding: 0;
    font-size: 24px;
  }

  @media screen and (min-width: 501px) and (max-width: 768px) {
    margin: 0 !important;
    padding: 0;
    font-size: 52px;
  }
}

.works-container {
  display: flex;
  flex-direction: row;
  gap: 16px;
  min-width: max-content;

  .work-card {
    display: flex;
    flex-direction: column;
    align-items: center;

    img,
    video {
      max-width: 400px;
      width: 100%;
      object-fit: cover;
      border-radius: 8px;
    }

    .work-label {
      margin-top: 10px;
      font-size: 16px;
      color: #fff;
      text-align: center;
    }
  }
}
</style>
